<div class="sidebar-upcoming-follow-up width-100p border-bottom-light pb-2">
  <div class="flex-between-center pt-2 pb-2">
    <p class="m-0 font-secondary-900 font-bold">UPCOMING FOLLOW-UP ({{upcomingFollowUps?.length}})</p>
    <p class="m-0 font-bold font-primary pointer" (click)="handleFollowUpPanel('view-upcoming')">View all</p>
  </div>

  <!-- Campaign card -->
  <div class="width-100p follow-up-card mb-2" *ngFor="let camapign of upcomingFollowUps | slice: 0 : 2; let i = index">
    <!-- Campaign title -->
    <div class="flex-start-center">
      <i class="fal fa-alarm-clock pr-2"></i>

      <p class="m-0 font-600" id="sidebar-upcoming-follow-up-campaign-title-{{i}}">{{camapign?.campaignTitle}}</p>
    </div>

    <!-- Campaign bottom -->
    <div class="flex-start-center">
      <i class="fal fa-calendar-alt font-gray-65 pr-2"></i>

      <p class="m-0 flex-between-center width-100p">
        <span class="font-12" id="sidebar-upcoming-follow-up-campaign-date-{{i}}">
          {{camapign?.scheduleAt | date: 'MMM d, yyyy hh:mma'}}
        </span>

        <span class="font-12" id="sidebar-upcoming-follow-up-order-no-{{i}}">
          {{!camapign?.order?.code? '' : 'R0# ' + camapign?.order?.code}}
        </span>
      </p>
    </div>
  </div>

  <div class="width-100p empty-upcoming-follow-up follow-up-card mb-2 flex-column flex-center-center"
    *ngIf="!upcomingFollowUps?.length">
    <p class="m-0">There are no Upcoming follow-ups</p>
    <p class="m-0 font-primary pointer" (click)="handleFollowUpPanel('view-eligible')" id="sidebar-add-upcoming-follow-up">
      <i class="fal fa-plus pr-2"></i>
      <span>Add follow-up</span>
    </p>
  </div>

  <div class="width-100p follow-up-card mb-2 pointer flex-center-center" (click)="handleFollowUpPanel('view-eligible')">
    <i class="fal fa-plus pr-2"></i>
    <span class="font-600">Recommended follow-ups</span>
  </div>
</div>
